<template>
    <v-dialog v-model="show" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Mutare</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <errors v-if="errors.length" :errors="errors"></errors>
                        <v-col md="12">
                            <v-treeview
                                v-if="allDirectoriesComputed.length"
                                :items="allDirectoriesComputed"
                                activatable
                                item-key="path"
                                item-text="name"
                                @update:active="handleTreeviewClick"
                            >
                                <template v-slot:prepend="{ item, open }">
                                    <v-icon :class="`ptv-${item.indent}`">
                                        mdi-folder
                                    </v-icon>
                                </template>
                                <template v-slot:label="{ item }">
                                    <span v-html="item.name"></span>
                                </template>
                            </v-treeview>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                    Renuntare
                </v-btn>
                <v-btn color="blue darken-1" ref="newFolderLocation" text @click="moveItem">
                    Mutare
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import MoveItemModal from "../../../../packages/media-manager/js/components/subcomponents/MoveItemModal";
    import Errors from '../Components/Errors';

    export default {
        extends: MoveItemModal,
        components: {
            Errors
        },
        computed: {
            allDirectoriesComputed() {
                if (this._.isNil(this.allDirectories)) return []
                const keys = Object.keys(this.allDirectories)
                return keys.map((key) => {
                    var indent = (this.allDirectories[key].match(/&nbsp;/g) || []).length
                    return {
                        path: key,
                        name: this.allDirectories[key].replaceAll('&nbsp;', ''),
                        indent: indent > 0 ? indent - 4 : indent,
                        children: []
                    }
                }).filter((item) => ['/'].indexOf(item.path) < 0)
            }
        },
        methods: {
            handleTreeviewClick(pathArray) {
                if (pathArray.length) {
                    this.newFolderLocation = pathArray[0]
                } else {
                    this.newFolderLocation = null
                }
            }
        }
    };
</script>
<style lang="scss">
    $rootPadding: 4;
    $spaceamounts: (4, 8, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88, 92, 96, 100);

    @each $space in $spaceamounts {
        .ptv-#{$space} {
            padding-left: #{$space * $rootPadding}px !important;
        }
    }
</style>
